import { Fragment, useState } from 'react';

import GitHUbImg from '../assets/svg/GitHub.png';
import LinkedIn from '../assets/svg/LinkedIn.png';

const Sidebar = (props) => {
  const [menuIsVisible, setMenuIsVisible] = useState(false);

  const clickHandler = () => {
    if (window.innerWidth < 912) {
      setMenuIsVisible(!menuIsVisible);
    }
  };

  return (
    <Fragment>
      <aside
        className={menuIsVisible ? 'sidebar visible' : 'sidebar'}
        onClick={clickHandler}
      >
        <nav className="navigation">
          <ul className="navigation__list">{props.children}</ul>
        </nav>
        <div className="social-link">
          <a href="https://github.com/JuanK81" target="_blank" rel="noreferrer">
            <img
              className="social-link__logo github"
              alt="logo"
              src={GitHUbImg}
            />
          </a>
          <a
            href="https://www.linkedin.com/in/juan-casals-dev/"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="social-link__logo linkedin"
              alt="logo"
              src={LinkedIn}
            />
          </a>
        </div>
      </aside>
      <button
        className={
          menuIsVisible
            ? ' navigation__navBtn--visible navigation__navBtn'
            : 'navigation__navBtn'
        }
        // className="navigation__navBtn"
        onClick={clickHandler}
      >
        {menuIsVisible ? 'CLOSE MENU' : 'MENU'}
      </button>
    </Fragment>
  );
};

export default Sidebar;
